// extracted by mini-css-extract-plugin
export var quillEditor = "_k2-1";
export var variable = "_k2-0";